import { getUnitFeatures, saveUnitFeatures } from '@lib/api';
import { useMutation, useQuery } from 'react-query';

export const useUnitFeaturesQuery = (unitId: string | undefined, onSuccess: () => void) => {
    if (unitId) {
        return useQuery(
            'unitFeatures',
            async () => {
                return await getUnitFeatures(unitId);
            },
            {
                onSuccess: onSuccess,
                refetchOnWindowFocus: false,
                refetchOnReconnect: 'always',
                enabled: false,
            },
        );
    } else {
        return {
            isFetching: false,
            refetch: () => Promise.resolve(null),
        };
    }
};

export const useUnitFeaturesMutation = () => {
    return useMutation<
        unknown,
        unknown,
        {
            unitId: string;
            address: string;
            bedrooms: number;
            bathrooms: number;
        },
        unknown
    >(async ({ unitId, address, bedrooms, bathrooms }) => {
        return await saveUnitFeatures(unitId, { address, bedrooms, bathrooms });
    });
};
